import { ConditionParams } from 'config/utils/types';
import { getNumPanels } from 'features/map/mapUtils';
import { BusinessChoiceType } from 'features/utils/types';
import { AnswersState } from 'schemas/answerStateSchema';
import { RootState } from './store';

export const AnswersSelector = (state: RootState) => state.answers;
export const AddressSelector = (state: RootState) => state.answers.address;
export const AddressGeoCodeSelector = (state: RootState) =>
  state.answers.addressDetails?.geoCode;
export const AddressPostcodeSelector = (state: RootState) =>
  state.answers.addressDetails?.postCode;
export const AddressDetailsSelector = (state: RootState) =>
  state.answers.addressDetails;
export const PanelSelector = (state: RootState) => state.answers.panelId;
export const RoofAngleSelector = (state: RootState) => state.answers.roofAngle;
export const RoofTypeSelector = (state: RootState) => state.answers.roofType;
export const MapDetailSelector = (state: RootState) => state.answers.mapDetail;

export const NumPanelFromMapSelector = (state: RootState) =>
  getNumPanels((state.answers as AnswersState).mapDetail?.panels);
export const NumPanelExplicitSelector = (state: RootState) =>
  state.answers.numPanelsExplicit;

export const ConsumptionSelector = (state: RootState) =>
  state.answers.consumption;

export const CounterSelector = (state: RootState) => state.answers.counter;
export const InverterSelector = (state: RootState) => state.answers.inverter;

export const BillSelector = (state: RootState) => state.answers.billAmount;
export const BatterySelector = (state: RootState) => state.answers.needBattery;
export const VehicleSelector = (state: RootState) => state.answers.needVehicle;
export const FlowSelector = (state: RootState) => state.answers.flowChoice;

export const StepParamsSelector = (state: RootState) => {
  const result: ConditionParams = {
    flowType: state.answers.businessChoice,
    flowComplexity: state.answers.flowChoice,
  };
  return result;
};
export const BusinessChoiceSelector = (state: RootState) =>
  state.answers.businessChoice as BusinessChoiceType | undefined;
export const isB2BSelector = (state: RootState) =>
  state.answers.businessChoice === 'b2b';

export const ExtraServicesSelector = (
  state: RootState
): { id?: string; label?: string }[] => state.answers.extraServices;
